import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const Calendar = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 24 24">
            <g>
                <path d="M3.9,3.3h16.2c1.3,0,2.3,1,2.3,2.3v15.1c0,1.3-1,2.3-2.3,2.3H3.9c-1.3,0-2.3-1-2.3-2.3V5.6 C1.6,4.4,2.6,3.3,3.9,3.3z M3.9,9.1v11.6h16.2V9.1H3.9z" />
                <path d="M13.2,13.7h3.5v3.5h-3.5V13.7z M6.2,1c0.6,0,1.2,0.5,1.2,1.2v3.5c0,0.6-0.5,1.2-1.2,1.2S5.1,6.3,5.1,5.6V2.2 C5.1,1.5,5.6,1,6.2,1z M17.8,1c0.6,0,1.2,0.5,1.2,1.2v3.5c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2V2.2 C16.6,1.5,17.1,1,17.8,1z" />
            </g>
        </svg>
    </SvgIcon>
);

export default Calendar;
